import React, { useState, useRef } from 'react';

import { StyleSheet, Platform } from 'react-native';
import { ApplicationProvider } from '@ui-kitten/components';
import { mapping, light as lightTheme } from '@eva-design/eva';
import { NavigationContainer } from '@react-navigation/native';
import { Provider } from "react-redux"
import { PersistGate } from 'redux-persist/integration/react'

import { store, persistor } from "./store"

import Root from "./app/scene"

export default function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <NavigationContainer onStateChange={params => console.log("STATE", params)}>
                    <ApplicationProvider mapping={mapping} theme={lightTheme}>
                        <Root/>
                    </ApplicationProvider>
                </NavigationContainer>
            </PersistGate>
        </Provider>
    );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
